import React from "react"
export function SouthAfricaFlag(props) {
  return (
    <svg viewBox="0 0 24 16" {...props}>
      <defs>
        <path id="prefix__path-1" d="M24 0v16H0V0h24" />
      </defs>
      <g
        id="prefix__South-Africa"
        stroke="none"
        strokeWidth={1}
        fill="none"
        fillRule="evenodd"
      >
        <g id="prefix__south-africa">
          <g id="prefix__south-africa-a-link" fill="#CECECE" fillRule="nonzero">
            <path id="prefix__south-africa-a" d="M24 0v16H0V0h24" />
          </g>
          <g id="prefix__Clipped">
            <mask id="prefix__mask-2" fill="#fff">
              <use xlinkHref="#prefix__path-1" />
            </mask>
            <g
              id="prefix__Group"
              mask="url(#prefix__mask-2)"
              fillRule="nonzero"
            >
              <g id="prefix__Path">
                <path
                  fill="#464655"
                  d="M0 3.6v10.8L7.2 9z"
                  transform="translate(-1 -1)"
                />
                <path
                  d="M3.6.5l8.1 6.3H26V1c0-.2-.2-.4-.5-.4L3.6.5z"
                  fill="#FF4B55"
                  transform="translate(-1 -1)"
                />
                <path
                  d="M3.6 17.5l8.1-6.3H26V17c0 .2-.2.5-.5.5H3.6z"
                  fill="#41479B"
                  transform="translate(-1 -1)"
                />
                <path
                  d="M2.9.5H.5C.2.5 0 .7 0 .9v1.8L7.9 9 0 15.2V17c0 .2.2.5.4.5h2.4l8.5-6.7H26V7.2H11.4L2.9.5z"
                  fill="#73AF00"
                  transform="translate(-1 -1)"
                />
                <path
                  fill="#F5F5F5"
                  d="M4.3.5H2.9l8.5 6.7H26v-.9H11.7z"
                  transform="translate(-1 -1)"
                />
                <path
                  fill="#FFE15A"
                  d="M0 2.8v1.1L6.4 9 0 14.1v1.1L7.9 9z"
                  transform="translate(-1 -1)"
                />
                <path
                  fill="#F5F5F5"
                  d="M11.4 10.8l-8.5 6.7h1.4l7.4-5.8H26v-.9z"
                  transform="translate(-1 -1)"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}
